export interface AdminBookingSearchCriteria {
  startDate?: string,
  bookingNumber?: string,
  buyerAccountId?: string,
  supplierAccountId?: string,
  locationId?: string,
  status?: string,
  assetTypeGroup?: string,
  brokered?: string,
  durationType?: string,
}

/** Keys that make the report search all dates while filled (see `withDateRangeBypass`). */
export const ADMIN_BOOKINGS_DATE_BYPASS_KEYS: readonly (keyof AdminBookingSearchCriteria)[] = ['bookingNumber'];
